/**
 * One-shot handoff for DM compose draft text.
 *
 * Message bodies must not travel in URL query params (page-view analytics,
 * history, referrers). Callers stash before navigating to `/messages/new`;
 * the page consumes once and clears.
 */
const COMPOSE_DRAFT_KEY = 'ah.dm.composeDraft.v1';

export function stashComposeDraft(body: string): void {
  try {
    if (!body) return;
    sessionStorage.setItem(COMPOSE_DRAFT_KEY, body);
  } catch {
    // private mode / quota — compose opens without prefill
  }
}

export function takeComposeDraft(): string {
  try {
    const value = sessionStorage.getItem(COMPOSE_DRAFT_KEY);
    sessionStorage.removeItem(COMPOSE_DRAFT_KEY);
    return value ?? '';
  } catch {
    return '';
  }
}
